<script>
import FormInput from '@/components/form/FormInput.vue';
import AppButton from '@/components/ui/AppButton.vue';
import Icons from '@/components/Icons.vue';
import ValidateMail from '@/components/ValidateMail.vue';
import LogoClub from '@/components/template/LogoClub.vue';
import { buildDiscourseAvatarUrl } from '@/views/discourse/utils/helpers.js';
import { googleAnalyticsEvent, googleAnalyticsParamEvent, GA_EVENTS } from '../utils/googleAnalyticsEvents';
import fakeMemberAvatar1 from '@/assets/img/examples/avatar-fake-1.jpg';
import fakeMemberAvatar2 from '@/assets/img/examples/avatar-fake-2.jpg';
import fakeMemberAvatar3 from '@/assets/img/examples/avatar-fake-3.jpg';
import fakeMemberAvatar4 from '@/assets/img/examples/avatar-fake-4.jpg';
import fakeMemberAvatar5 from '@/assets/img/examples/avatar-fake-5.jpg';

export default {
	name: 'Entrar',
	components: {
		FormInput,
		AppButton,
		Icons,
		ValidateMail,
		LogoClub
	},
	data() {
		return {
			accountActive: false,
			passwordReset: false,
			resetSenha: false,
			//showRecover: true,
			user: {
				email: "",
				password: ""
			},
			sending: false,
			feedback: '',
			mensagemReset: '',
			blocked: [],
			showPassword: false,
			view: 'login',
			validateMessageType: '',
			validateMessageFeedback: false,
			isLoggingIn: false,
			isSendingToken: false,
			isResendingValidation: false,
				queries: '',
				latestCommunityPosts: []
		};
	},
	created() {
		// SEO ======
		document.title = this.$t('meta.entrar.title');
		document.querySelector('meta[name="description"]').setAttribute('content', this.$t('meta.entrar.description'));
		document.querySelector('meta[name="keywords"]').setAttribute('content', this.$t('meta.entrar.keywords'));

		// Definindo as Meta Tags de Open Graph (og:*)
		document.querySelector('meta[property="og:title"]').setAttribute('content', this.$t('meta.entrar.title'));
		document.querySelector('meta[property="og:description"]').setAttribute('content', this.$t('meta.entrar.description'));
		// // Definindo as Meta Tags do Twitter
		document.querySelector('meta[name="twitter:title"]').setAttribute('content', this.$t('meta.entrar.title'));
		document.querySelector('meta[name="twitter:description"]').setAttribute('content', this.$t('meta.entrar.description'));
		// SEO ======

	},
	mounted() {
		this.queries = new URLSearchParams(this.$route.query)
		if (this.$route.query?.resetError === 'true') {
			this.togglePass()
			this.mensagemReset = this.$route.query?.message
		}
		this.accountActive  = this.$route.query?.ativarConta === 'true',
		this.resetSenha = this.$route.query?.resetarSenha === 'true'
		this.passwordReset = this.$route.query?.passwordReset === 'true'

		if (this.discourseEnabled) {
			this.loadCommunityPreview()
		}

	},
	computed: {
		isBrazilMarket() {
			return import.meta.env.VITE_BASE_PATH === '/br/'
		},
		discourseEnabled() {
			return __DISCOURSE_ENABLED__
		},
		fakeMembers() {
			return [
				{ id: 'fake-1', name: 'LG Family Club', avatar: fakeMemberAvatar1 },
				{ id: 'fake-2', name: 'LG Family Club', avatar: fakeMemberAvatar2 },
				{ id: 'fake-3', name: 'LG Family Club', avatar: fakeMemberAvatar3 },
				{ id: 'fake-4', name: 'LG Family Club', avatar: fakeMemberAvatar4 },
				{ id: 'fake-5', name: 'LG Family Club', avatar: fakeMemberAvatar5 }
			]
		},
		displayMembers() {
			return this.discourseEnabled && this.communityPreview.length
				? this.communityPreview.slice(0, 5)
				: this.fakeMembers
		},
		communityPreview() {
			return this.latestCommunityPosts
				.map((post) => {
					const parser = new DOMParser()
					const document = parser.parseFromString(post.cooked || '', 'text/html')
					const mediaContainers = new Set()

					document.body.querySelectorAll('img, source').forEach((element) => {
						mediaContainers.add(
							element.closest('a, figure, picture, [class*="lightbox"]') || element
						)
					})
					document.body
						.querySelectorAll(
							'a.lightbox, a.attachment, [class*="lightbox"], [class*="attachment"], [data-download-href], figure, picture, video, audio, iframe'
						)
						.forEach((element) => mediaContainers.add(element))
					document.body.querySelectorAll('a[href]').forEach((element) => {
						const href = element.getAttribute('href') || ''
						if (/\/uploads\/|\.(?:avif|gif|jpe?g|png|svg|webp)(?:$|[?#])/i.test(href)) {
							mediaContainers.add(element)
						}
					})
					mediaContainers.forEach((element) => element.remove())
					const message = (document.body.textContent || '').replace(/\s+/g, ' ').trim()

					return {
						id: post.id,
						name: post.name || post.username,
						username: post.username,
						message,
						avatar: buildDiscourseAvatarUrl(post.avatar_template, 48)
					}
				})
				.filter((post) => post.message && post.name)
		},
		loginValidation: function () {
			return {
				email: !!this.user.email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.user.email),
				password: !!this.user.password,
			}
		},
		resetValidation: function () {
			return {
				email: !!this.user.email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.user.email),
			}
		},
		isValid: function () {
			var ret = true
			Object.entries(this.loginValidation).forEach(([key, value]) => {
				if (!value)
					ret = false;
			});
			return ret;
		},
		isValidReset: function () {
			var ret = true
			Object.entries(this.resetValidation).forEach(([key, value]) => {
				if (!value)
					ret = false;
			});
			return ret;
		},
	},
	methods: {
		loadCommunityPreview() {
			this.$store.dispatch('discourse/fetchLatestPostsPreview', { limit: 10 })
				.then((posts) => {
					this.latestCommunityPosts = posts
				})
				.catch(() => {
					this.latestCommunityPosts = []
				})
		},
			toggleShowPassword() {
			this.showPassword = !this.showPassword;
		},
		loginAct(event) {
			event.preventDefault()
			if (this.isLoggingIn) return

			this.feedback = ''
			this.sending = true;

			const gaEventName = GA_EVENTS.SIGN_IN
			const gaParameters = {
				local_time_date: new Date().toISOString(),
			}

			if (this.isValid) {
				this.isLoggingIn = true
				this.$store.dispatch("auth/login", this.user)
					.then(
						(resp) => {
							googleAnalyticsEvent(gaEventName, gaParameters)
							googleAnalyticsParamEvent(['lgfamilyclub', gaEventName, window.location.pathname, window.location.href])

							if (this.queries && !!this.queries.get('redirect')) {
								this.$store.dispatch('route/click', { to: this.queries.get('redirect'), element: '', content: '', index: '' }).catch(e => {
									this.$router.push("/");
								});
							} else
								this.$router.push("/");
						},
						(error) => {
							console.log(error)
							const errorMessage = error.response?.data?.error?.message;

							if (errorMessage === 'Usuário bloqueado') {
								this.feedback = this.$t('feedbackMessage.userBlocked');
							} else if (errorMessage === 'Email de ativação já enviado recentemente') {
								this.view = 'validate';
								this.validateMessageType = 'under24';
							} else if (errorMessage === 'Email de ativação expirado') {
								this.view = 'validate';
								this.validateMessageType = 'over24';
							} else {
								this.feedback = this.$t('feedbackMessage.userPass');
							}
						}
					).catch(error => {
						console.log(error)
						this.feedback = this.$t('feedbackMessage.userPass');
					}).finally(() => {
						this.isLoggingIn = false
					});
			}

		},
		sendTokenEmail(event) {
			event.preventDefault()
			this.sending = true
			if (this.isSendingToken) return

			if (this.isValidReset) {
				if (!this.blocked.includes(this.user.email.toLowerCase())) {
					this.isSendingToken = true
					this.$store.dispatch("auth/token", this.user.email).then(
						(resp) => {
							this.passwordReset = true
							this.togglePass()
						},
						(error) => {
							const message = error.response?.data?.error?.message
							console.log(error)

							if (message === 'activation-email-already-sent') {
								this.validateMessageType = 'under24'
								this.view = 'validate'
							} else if (message === 'activation-email-expired') {
								this.validateMessageType = 'over24'
								this.view = 'validate'
							} else {
								this.feedback = message || this.$t('feedbackMessage.resetPass')
							}
						}
					).catch(error => {
						console.log(error)
						this.feedback = error.response?.error?.message || this.$t('feedbackMessage.resetPass')
					}).finally(() => {
						if (this.feedback == this.$t('feedbackMessage.unotFound'))
							this.blocked.push(this.user.email.toLowerCase())
						this.isSendingToken = false
					})
				} else {
					this.feedback = this.$t('feedbackMessage.unotFound')
				}
			}
		},
		togglePass() {
			this.sending = false
			this.feedback = ""
			this.sending = false
			this.view = this.view === 'login' ? 'recover' : 'login'
		},
		resendValidationEmail() {
			if (this.isResendingValidation) return
			this.isResendingValidation = true
			const body = { email: this.user.email }
			this.$store.dispatch("auth/resendValidationEmail", body)
				.then((resp) => {
					this.view = 'validate';
					this.validateMessageFeedback = true;
				})
				.catch((error) => {
					console.log(error);
					const message = error.response?.data?.error?.message

					if (message === 'activation-email-already-sent') {
						this.validateMessageFeedback = false;
						this.validateMessageType = 'under24'
						this.view = 'validate'
					}

				})
				.finally(() => {
					this.isResendingValidation = false
				})
		}
	},
	beforeRouteEnter(to, from, next) {
		window.scrollTo(0, 0);
		next();
	}
}

</script>

<template>
	<section class="auth-login" data-qa="login-page">
		<div class="auth-login__overlay" aria-hidden="true"></div>

		<div class="auth-login__layout">
			<section class="auth-login__hero" aria-labelledby="auth-login-title">
				<div class="auth-login__hero-copy">
					<h1 id="auth-login-title">{{ $t('signIn.heroTitle') }}</h1>
					<p>{{ $t('signIn.heroDescription') }}</p>
				</div>

				<div v-if="displayMembers.length" class="auth-login__community">
					<div class="auth-login__members">
						<ul data-qa="login-community-members-list" :aria-label="$t('signIn.communityMembersLabel')">
							<li
								v-for="member in displayMembers"
								:key="member.id"
								data-qa="login-community-member-item"
								:data-qa-id="member.id"
							>
								<img
									data-qa="login-community-member-image"
									:data-qa-id="member.id"
									:src="member.avatar"
									:alt="member.name"
									width="40"
									height="40"
									loading="lazy"
								>
							</li>
							<li class="auth-login__members-count" aria-hidden="true">+280k</li>
						</ul>
						<p>{{ $t('signIn.communityMembers') }}</p>
					</div>

					<div
						v-if="discourseEnabled && communityPreview.length"
						class="auth-login__comments"
						:class="`auth-login__comments--${communityPreview.length}`"
						aria-live="off"
					>
						<article
							v-for="post in communityPreview"
							:key="post.id"
							class="auth-login__comment"
							data-qa="login-community-comment-card"
							:data-qa-id="post.id"
						>
							<img
								class="auth-login__comment-avatar"
								data-qa="login-community-comment-author-image"
								:data-qa-id="post.id"
								:src="post.avatar"
								alt=""
								width="40"
								height="40"
								loading="lazy"
							>
							<p>
								<strong data-qa="login-community-comment-author-title" :data-qa-id="post.id">{{ post.name }}</strong>
								<span aria-hidden="true"> · </span>
								<span data-qa="login-community-comment-message-text" :data-qa-id="post.id">“{{ post.message }}”</span>
							</p>
						</article>
					</div>
				</div>
			</section>

			<aside class="auth-login__card">
				<header class="auth-login__card-header">
					<LogoClub logoSymbol="var(--black)" logoName="var(--lg-red-active)" class="auth-login__logo" />
					<p v-if="view === 'login'">{{ $t('signIn.welcomeBack') }}</p>
					<p v-else-if="view === 'recover'">{{ $t('signIn.recuperarSenhaDesc') }}</p>
				</header>

				<section v-if="view === 'login'" id="login" aria-labelledby="login-form-title">
					<h2 id="login-form-title" class="visually-hidden">{{ $t('signIn.titleSign') }}</h2>
					<form class="auth-login__form" data-qa="login-form" @submit.prevent="loginAct">
						<span class="serverReturn" data-qa="login-feedback-error" v-show="feedback">{{ feedback }}</span>
						<FormInput
							data-qa="login-email-input"
							:label="$t('form.labels.mail')"
							inputId="mail"
							inputType="email"
							:placeholder="$t('form.placeholder.email')"
							:isRequired="true"
							v-model="user.email"
							:isError="sending && !loginValidation.email"
							:messageError="$t('form.messageError.email')"
							autocomplete="email"
						/>

						<FormInput
							data-qa="login-password-input"
							:label="$t('form.labels.password')"
							v-model="user.password"
							:inputType="showPassword ? 'text' : 'password'"
							inputId="pass"
							:placeholder="$t('form.placeholder.password')"
							:isRequired="true"
							:isError="sending && !loginValidation.password"
							:messageError="$t('form.messageError.password')"
							autocomplete="current-password"
						>
							<button
								type="button"
								class="toggle__password"
								data-qa="login-password-visibility-toggle"
								@click="toggleShowPassword"
								:aria-label="showPassword ? $t('signIn.hidePassword') : $t('signIn.showPassword')"
								:title="showPassword ? $t('signIn.hidePassword') : $t('signIn.showPassword')"
							>
								<Icons :name="showPassword ? 'eye' : 'eyeSlash'" />
							</button>
						</FormInput>

						<div class="auth-login__forgot">
							<AppButton
								data-qa="login-forgot-password-button"
								variant="link"
								@click="$event.preventDefault(); togglePass()"
								:aria-label="$t('signIn.recuperarSenhaTitle')"
							>
								{{ $t('signIn.forgotPass') }}
							</AppButton>
						</div>

						<AppButton
							data-qa="login-submit-button"
							type="submit"
							variant="primary"
							:disabled="isLoggingIn"
							:loading="isLoggingIn"
							:aria-label="$t('buttons.entrar')"
							class="auth-login__submit"
						>
							{{ $t('buttons.entrar') }}
						</AppButton>
					</form>

					<footer class="auth-login__card-footer">
						<div class="auth-login__divider">
							<span>{{ $t('signIn.communityBy') }} LG</span>
						</div>
						<p>{{ $t('signIn.communityQuestion') }}</p>
						<AppButton
							data-qa="login-signup-link"
							variant="secondary"
							:to="$router.resolve({ name: 'signup' }).path"
							:aria-label="$t('buttons.fazerCadastro')"
						>
							{{ $t('signIn.signUpNow') }}
						</AppButton>
					</footer>
				</section>

				<section v-else-if="view === 'recover'" id="recoverPass" aria-labelledby="recover-title">
					<h2 id="recover-title">{{ $t('signIn.recuperarSenhaTitle') }}</h2>
					<form class="auth-login__form" data-qa="login-recovery-form" @submit.prevent="sendTokenEmail">
						<span class="serverReturn" data-qa="login-recovery-feedback-error" v-show="feedback">{{ feedback }}</span>
						<span class="serverReturn" data-qa="login-recovery-message-alert" v-show="mensagemReset">{{ mensagemReset }}</span>
						<FormInput
							data-qa="login-recovery-email-input"
							:label="$t('form.labels.mail')"
							:isError="sending && !resetValidation.email"
							:messageError="$t('form.messageError.email')"
							v-model="user.email"
							inputId="recover-mail"
							inputType="email"
							:placeholder="$t('form.placeholder.email')"
							:isRequired="true"
							autocomplete="email"
						/>

						<div class="auth-login__recovery-actions">
							<AppButton data-qa="login-recovery-submit-button" type="submit" variant="primary" :disabled="isSendingToken" :loading="isSendingToken">
								{{ $t('buttons.sendMail') }}
							</AppButton>
							<AppButton data-qa="login-recovery-back-button" variant="secondary" @click="$event.preventDefault(); togglePass()">
								{{ $t('buttons.voltar') }}
							</AppButton>
						</div>
					</form>
				</section>

				<ValidateMail
					v-else-if="view === 'validate'"
					data-qa="login-validation-section"
					:key="validateMessageType"
					:message-type="validateMessageType"
					:feedback="validateMessageFeedback"
					:is-resending="isResendingValidation"
					@reenviar="resendValidationEmail"
					@voltar="togglePass"
				/>
			</aside>
		</div>
	</section>
</template>

<style lang="sass" scoped>
@use '../assets/sass/utilities/_colors' as *
@use '../assets/sass/utilities/_responsive' as *
@use '../assets/sass/utilities/_mixin' as *

.auth-login
	position: relative
	flex: 1
	display: flex
	min-height: 48rem
	isolation: isolate
	background: url('../assets/img/auth-family-club.png') center 52% / cover no-repeat
	overflow: hidden

	&__overlay
		position: absolute
		inset: 0
		z-index: -1
		background: linear-gradient(90deg, rgba(var(--black-rgb), .76) 0%, rgba(var(--black-rgb), .48) 47%, rgba(var(--black-rgb), .12) 100%), linear-gradient(0deg, rgba(var(--black-rgb), .62) 0%, transparent 65%)

	&__layout
		width: min(100%, 77.5rem)
		min-height: 48rem
		margin-inline: auto
		padding: 3rem 1.25rem
		display: grid
		grid-template-columns: minmax(0, 1fr)
		align-items: center
		gap: 2rem

	&__hero
		color: var(--white)
		display: flex
		flex-direction: column
		justify-content: center
		min-width: 0

	&__hero-copy
		max-width: 35rem

		h1
			max-width: 10ch
			margin-bottom: 1.25rem
			color: var(--white)
			font-family: var(--lgei-headline)
			font-size: clamp(2.8rem, 7vw, 5.5rem)
			font-weight: 800
			line-height: .94
			letter-spacing: -.035em
			text-transform: uppercase
			text-wrap: balance

		p
			max-width: 28rem
			color: var(--white)
			font-family: var(--lgei-text)
			font-size: clamp(1rem, 1.5vw, 1.125rem)
			line-height: 1.5
			text-wrap: balance

	&__community
		max-width: 32rem
		margin-top: 1.5rem
		padding-top: 1.5rem
		border-top: 1px solid rgba(var(--white-rgb), .28)

	&__members
		display: flex
		align-items: center
		gap: 1rem

		ul
			display: flex
			align-items: center
			flex-shrink: 0

		li
			width: 2.5rem
			height: 2.5rem
			margin-left: -.75rem
			border: 2px solid rgba(var(--white-rgb), .9)
			border-radius: 50%
			overflow: hidden
			background: var(--lg-mid-gray-100)

			&:first-child
				margin-left: 0

		img
			width: 100%
			height: 100%
			object-fit: cover

		p
			color: var(--white)
			font-weight: 600
			font-size: .95rem

	&__members-count
		display: flex
		align-items: center
		justify-content: center
		background: var(--lg-red-active) !important
		color: var(--white)
		font-size: .7rem
		font-weight: 700

	&__comments
		position: relative
		height: 4rem
		margin-top: 1rem

		@for $count from 2 through 6
			&--#{$count} .auth-login__comment
				animation-duration: #{$count * 4}s

		&--1 .auth-login__comment
			opacity: 1
			animation: none

		.auth-login__comment
			@for $index from 2 through 6
				&:nth-child(#{$index})
					animation-delay: #{($index - 1) * 4}s

	&__comment
		position: absolute
		inset: 0
		display: flex
		align-items: center
		gap: .75rem
		padding: .5rem 1rem .5rem .5rem
		border: 1px solid rgba(var(--white-rgb), .22)
		border-radius: 999px
		background: rgba(var(--black-rgb), .4)
		backdrop-filter: blur(.5rem)
		opacity: 0
		animation: commentCycle 24s ease-in-out infinite

		p
			min-width: 0
			overflow: hidden
			color: var(--white)
			font-size: .875rem
			line-height: 1.35
			white-space: normal
			+line-limited(2)

	&__comment-avatar
		width: 2.5rem
		height: 2.5rem
		flex-shrink: 0
		border-radius: 50%
		background: var(--lg-red-active)
		object-fit: cover

	&__card
		width: min(100%, 26.25rem)
		justify-self: center
		padding: clamp(1.5rem, 4vw, 2.5rem)
		border-radius: 1.25rem
		background: var(--white)
		box-shadow: var(--shadow-default)
		animation: fadeUp .5s ease

		h2
			margin-bottom: 1.5rem
			font-family: var(--lgei-headline)
			font-size: 1.75rem

	&__card-header
		margin-bottom: 1.75rem

		p
			margin-top: .5rem
			color: var(--club--text-default)
			font-size: .95rem

	&__logo
		width: min(100%, 15rem)
		display: block

	&__form
		display: flex
		flex-direction: column
		gap: 1.1rem

	&__forgot
		display: flex
		justify-content: flex-end
		margin-top: -.35rem

	&__submit
		width: 100%
		margin-top: .35rem

	&__card-footer
		margin-top: 1.75rem
		text-align: center

		> p
			margin: 1.75rem 0 .75rem
			color: var(--color-grey-700)
			font-size: .875rem

		.AppButton
			width: 100%

	&__divider
		display: flex
		align-items: center
		gap: .75rem
		color: var(--color-grey-500)
		font-size: .75rem

		&::before, &::after
			content: ''
			flex: 1
			height: 1px
			background: var(--lg-light-gray-300)

	&__recovery-actions
		display: flex
		flex-wrap: wrap
		gap: .75rem
		margin-top: .75rem

		.AppButton
			flex: 1

	+respond-to($breakpoint-xl-min)
		background-position: center

		&__layout
			grid-template-columns: minmax(0, 1fr) 26.25rem
			gap: 4rem
			padding: 3.25rem 2rem

		&__card
			justify-self: end

	+respond-to($sm-device-max)
		min-height: auto
		background-image: url('../assets/img/auth-family-club-mobile.png')
		background-position: center

		&__overlay
			background: linear-gradient(0deg, rgba(var(--black-rgb), .8) 0%, rgba(var(--black-rgb), .44) 72%, rgba(var(--black-rgb), .2) 100%)

		&__layout
			min-height: auto
			align-content: space-between
			gap: clamp(2rem, 8vw, 3rem)
			padding-block: clamp(3rem, 12vw, 5rem)

		&__hero-copy
			width: 100%
			margin-inline: auto
			padding-top: 0
			text-align: center

			h1, p
				margin-inline: auto

		&__community
			display: none

		&__card
			justify-self: center

.auth-login :deep(.box--form .input-wrapper input)
	border: 1px solid var(--lg-light-gray-300)

	&:focus-visible
		border-color: var(--lg-red-active)
		outline: 2px solid rgba(var(--lg-red-active-rgb), .2)
		outline-offset: 1px

.visually-hidden
	position: absolute !important
	width: 1px !important
	height: 1px !important
	padding: 0 !important
	margin: -1px !important
	overflow: hidden !important
	clip: rect(0, 0, 0, 0) !important
	white-space: nowrap !important
	border: 0 !important

@keyframes fadeUp
	from
		opacity: 0
		transform: translateY(.75rem)
	to
		opacity: 1
		transform: none

@keyframes commentCycle
	0%, 100%
		opacity: 0
		transform: translateY(.75rem)
	3%, 14%
		opacity: 1
		transform: translateY(0)
	17%
		opacity: 0
		transform: translateY(-.75rem)

@media (prefers-reduced-motion: reduce)
	.auth-login__card
		animation: none

	.auth-login__comment
		display: none
		animation: none

		&:first-child
			display: flex
			opacity: 1
			transform: none
</style>
